module.exports = __webpack_public_path__ + "static/media/business.63a85151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/business.jpg
// module id = 30
// module chunks = 0